import { HexContainer } from '../hex-container/hex-container';
import FaceEnroll from '../../../../assets/face-enroll.svg?react';
import './enrollment-header.less';
import {
  Banner,
  type NOTIF_BANNER_TYPE,
  type BannerProps,
} from '../../../Banner/banner';
import FaceBioWarningImg from '../../../../assets/face-bio-orange.svg?react';
import FaceBioErrorImg from '../../../../assets/face-bio-red.svg?react';

interface EnrollmentHeaderProps {
  hexImage?: React.ReactNode;
  banner?: BannerProps;
}

export const EnrollmentHeader = ({
  hexImage = <FaceEnroll />,
  banner,
}: EnrollmentHeaderProps) => {
  const renderImage = () => {
    switch (banner?.status) {
      case 'error':
        return <FaceBioErrorImg />;
      case 'warning':
        return <FaceBioWarningImg />;
      default:
        return hexImage;
    }
  };
  return (
    <div className={`enrollment-header ${banner ? banner.status : ''}`}>
      {banner && <Banner {...banner} className="enroll-banner" />}
      <HexContainer className="authn-layout-header-hex" icon={renderImage()} />
    </div>
  );
};
